import {
  Box,
  Typography,
  Button,
  Tabs,
  Tab,
  makeStyles,
  Divider,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useState } from "react";
import { Error, LoadingPage } from "react-admin";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import useMerchantSetting from "../../../hooks/useMerchantSetting";
import useUpdateMerchantSetting from "../../../hooks/useUpdateMerchantSetting";
import LayoutContainer from "../components/LayoutContainer";
import TextFieldNoBorder from "../../../components/TextFieldNoBorder";
import { removeEmptyFieldfromObject } from "../../../utils";
import { usePopup } from "react-hook-popup";
import SimplePopupDialog from "../../../components/SimplePopupDialog";
import useBadges from "../../../hooks/useBadges";
import useBatchUpdateBadgeSetting from "../../../hooks/useBatchUpdateBadgeSetting";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
const useStyles = makeStyles((theme) => ({
  pointContainer: {
    display: "grid",
    gridTemplateColumns: "200px 150px 50px 20px 150px auto",
    gridGap: "10px",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  codeContainer: {
    display: "grid",
    gridTemplateColumns: "200px 150px auto",
    gridGap: "10px",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  badgeContainer: {
    display: "grid",
    gridTemplateColumns: "200px 150px auto",
    gridGap: "10px",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  tab: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
  },
  input: {
    color: theme.orange,
  },
  save: {
    width: 300,
    height: 50,
    marginTop: 10,
    fontSize: 30,
    margin: "0 auto",
    alignSelf: "center",
  },
}));
const MerchantSettingEdit = () => {
  const classes = useStyles();
  const [adjustCode, setAdjustCode] = useState();
  const [voidCode, setVoidCode] = useState();
  const [earnCash, setEarnCash] = useState();
  const [earnPoint, setEarnPoint] = useState();
  const [redeemCash, setRedeemCash] = useState();
  const [redeemPoint, setRedeemPoint] = useState();
  const { loading, error, setting } = useMerchantSetting();
  const { loading: badgeLoading, error: badgeError, badges } = useBadges();
  const { updateMerchant } = useUpdateMerchantSetting();
  const [showAdjust, setShowAdjust] = useState(false);
  const [showVoid, setShowVoid] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [badgesValue, setBadgesValue] = useState([]);
  const { updateBadges } = useBatchUpdateBadgeSetting();
  //Data is {id:<badgeId>,conditionValue: conditionVAalue, conditionId}
  const [showPopup] = usePopup("success", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      onConfirm={message?.onConfirm}
    />
  ));

  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  if (loading || badgeLoading) return <LoadingPage />;
  if (error || badgeError) return <Error error={error || badgeError} />;

  const handleUpdateBadges = async () => {
    const result = await updateBadges(badgesValue);

    if (result.error) {
      return showAlert({
        title: "Error",
        message: JSON.stringify(result.message),
      });
    }
    showPopup({
      title: "Success",
      message:
        "Update successfully, You need to logout and login again to make change",
      onConfirm: () => {
        window.location.reload();
      },
    });
  };

  const handleUpdate = async () => {
    const cleanObject = removeEmptyFieldfromObject({
      authorize_code: {
        adjust: adjustCode,
        void: voidCode,
      },
      configuration: {
        earn_cash: earnCash ? Number(earnCash) : null,
        earn_point: earnPoint ? Number(earnPoint) : null,
        redeem_point: redeemPoint ? Number(redeemPoint) : null,
        redeem_cash: redeemCash ? Number(redeemCash) : null,
      },
      __v: setting.__v,
    });
    const result = await updateMerchant(cleanObject);

    if (result.error) {
      return showAlert({
        title: "Error",
        message: JSON.stringify(result.message),
      });
    }
    showPopup({
      title: "Success",
      message:
        "Update successfully, You need to logout and login again to make change",
      onConfirm: () => {
        window.location.reload();
      },
    });
  };

  const handleChangeBadgeValue = (index, value) => {
    const tempBadgeValues = [...badgesValue];
    let toChangeBadgeIndex = tempBadgeValues.findIndex(
      (temp) => temp.id === badges[index].id
    );
    if (toChangeBadgeIndex !== -1) {
      //Found
      tempBadgeValues[toChangeBadgeIndex].conditionValue = Number(value);
      return setBadgesValue([...tempBadgeValues]);
    }
    //Not Found
    tempBadgeValues.push({
      id: badges[index].id,
      conditionValue: Number(value),
      conditionId: badges[index].conditions[0].condition_id,
      __v: badges[index].__v,
    });
    return setBadgesValue([...tempBadgeValues]);
  };

  return (
    <LayoutContainer>
      <SfBreadcrumbs lower path="Management/Configuration" />
      <Box marginTop="10px">
        <Tabs
          value={tabIndex}
          onChange={(_, index) => setTabIndex(index)}
          indicatorColor="primary"
          variant="fullWidth"
          textColor="primary"
          centered
        >
          <Tab label="POINT VALUE"></Tab>
          <Tab label="AUTHORIZATION CODE"></Tab>
          <Tab label="THRESHOLD"></Tab>
        </Tabs>
        <TabPanel value={tabIndex} index={0}>
          <Box className={classes.pointContainer}>
            <Box>
              <Typography>Earn</Typography>
              <Typography>(cash to points)</Typography>
            </Box>
            <TextFieldNoBorder
              defaultValue={setting.configuration.earn_cash}
              onChange={(e) => setEarnCash(e.target.value)}
              type="number"
            />
            <Typography>{"THB"}</Typography>
            <ArrowForwardIosIcon />
            <TextFieldNoBorder
              defaultValue={setting.configuration.earn_point}
              onChange={(e) => setEarnPoint(e.target.value)}
              type="number"
            />
            <Typography>Pts.</Typography>
          </Box>
          <Divider />
          <Box className={classes.pointContainer}>
            <Box>
              <Typography>Redeem</Typography>
              <Typography>(points to cash)</Typography>
            </Box>

            <TextFieldNoBorder
              defaultValue={setting.configuration.redeem_point}
              onChange={(e) => setRedeemPoint(e.target.value)}
              type="number"
            />
            <Typography>{"Pts"}</Typography>
            <ArrowForwardIosIcon />
            <TextFieldNoBorder
              defaultValue={setting.configuration.redeem_cash}
              onChange={(e) => setRedeemCash(e.target.value)}
              type="number"
            />
            <Typography>{"THB"}</Typography>
          </Box>
          <Divider />
          <Button
            className={classes.save}
            color="primary"
            variant="contained"
            onClick={handleUpdate}
          >
            Save
          </Button>
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Box className={classes.codeContainer}>
            <Typography>Adjust Code</Typography>
            <TextFieldNoBorder
              defaultValue={setting.authorize_code.adjust}
              type={showAdjust ? "text" : "password"}
              onChange={(e) => setAdjustCode(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowAdjust(!showAdjust)}
                  >
                    {showAdjust ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Box>
          <Divider />
          <Box className={classes.codeContainer}>
            <Typography>Void Code</Typography>
            <TextFieldNoBorder
              defaultValue={setting.authorize_code.void}
              type={showVoid ? "text" : "password"}
              onChange={(e) => setVoidCode(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowVoid(!showVoid)}
                  >
                    {showVoid ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Box>
          <Divider />
          <Button
            className={classes.save}
            color="primary"
            variant="contained"
            onClick={handleUpdate}
          >
            Save
          </Button>
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          {badges.map((badge, index) => {
            return (
              <>
                <Box className={classes.badgeContainer}>
                  <Typography>{badge.name}</Typography>
                  <TextFieldNoBorder
                    defaultValue={badge.conditions[0].value}
                    onChange={(e) =>
                      handleChangeBadgeValue(index, e.target.value)
                    }
                    type="number"
                  />
                  <Typography>{getUnit(badge.name)}</Typography>
                </Box>
                <Divider />
              </>
            );
          })}
          <Button
            className={classes.save}
            color="primary"
            variant="contained"
            onClick={handleUpdateBadges}
          >
            Save
          </Button>
        </TabPanel>
        <PermissionChecker code="Page.Merchant.Management.Configuration" />
      </Box>
    </LayoutContainer>
  );
};

const getUnit = (badgeName) => {
  if (badgeName === "Big Spender") {
    return "THB";
  }
  if (badgeName === "Frequent Member") {
    return "Trans";
  }
  return "UNITS";
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={classes.tab}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default MerchantSettingEdit;
